import React from 'react';
import { connect } from 'react-redux';

const ACTIVE_INTERVAL = 1000 * 60 * 10; // 10 mins in ms

const DeploymentStats = ({ active, online }) => (
  <div>
    {active} active, {online} online
  </div>
);

export default connect(
  ({
    entities: {
      deployments: { deployments, latestHeartbeats },
    },
  }) => {
    const activeDeployments = deployments.filter(({ active }) => active);
    const online = deployments.filter(({ site }) => {
      const hb = latestHeartbeats[site];
      return hb && hb.timestamp > new Date().getTime() - ACTIVE_INTERVAL;
    });
    return { active: activeDeployments.length, online: online.length };
  }
)(DeploymentStats);
